module.exports = __webpack_public_path__ + "img/bg_avatar_male_83.3a8471ad.png";